import React, { useRef, useState } from "react";
import MaterialReactTable from "material-react-table";
import {
  Paper,
  Snackbar,
  Alert,
  Box,
  Button,
  MenuItem,
  IconButton,
  Dialog,
  Typography,
} from "@mui/material";
import PageTitle from "../../components/PageTitle/PageTitle";
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Visibility as ViewIcon,
} from "@mui/icons-material";
import {
  ViewDoctor,
  AddDoctor,
  useDeleteDoctor,
  useGetDoctors,
} from "../../components/DoctorComponents";
import columns from "./DoctorsColumns";
import { LoadingError, LoadingPaper } from "../../components/LoadingComponents";
import { useAuthUser } from "react-auth-kit";
import { useLocation } from "react-router";

function Doctors(props) {
  const filter = useLocation()?.state || null;

  const openInEditMode = useRef(false);
  const authUser = useAuthUser();

  // === web service queries ===
  const doctorsQuery = useGetDoctors();
  const deleteMutation = useDeleteDoctor();

  // === AddDoctor modal handling ===
  const [openAddDoctor, setOpenAddDoctor] = useState(false);
  const handleOpenAddDoctor = () => {
    setOpenAddDoctor(true);
  };
  const handleCloseAddDoctor = () => {
    setOpenAddDoctor(false);
  };

  // === ViewDoctor modal handling ===
  const [openViewDoctor, setOpenViewDoctor] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState({});
  const handleOpenViewDoctor = (doctor) => {
    setSelectedDoctor(doctor);
    setOpenViewDoctor(true);
  };
  const handleCloseViewDoctor = () => {
    setOpenViewDoctor(false);
  };

  const tableColumns = columns;

  return (
    <main style={{ width: "100%" }}>
      <Dialog open={openAddDoctor}>
        <AddDoctor closeModal={handleCloseAddDoctor} />
      </Dialog>

      <Dialog open={openViewDoctor} fullScreen>
        <ViewDoctor
          _editMode={openInEditMode.current}
          doctor_id={selectedDoctor}
          closeModal={handleCloseViewDoctor}
        />
      </Dialog>

      <PageTitle title="Professionisti Sanitari" />
      <Paper
        style={{ minHeight: "fitContent", margin: "3vh", maxWidth: "96%" }}
      >
        <Box>
          <Button
            style={{ margin: "15px" }}
            color="primary"
            onClick={handleOpenAddDoctor}
            variant="contained"
          >
            AGGIUNGI PROFESSIONISTA SANITARIO
          </Button>
        </Box>
        {doctorsQuery.isLoading ? (
          <LoadingPaper />
        ) : doctorsQuery.isError ? (
          <LoadingError error={doctorsQuery.error} />
        ) : (
          doctorsQuery.isSuccess && (
            <MaterialReactTable
              columns={tableColumns}
              data={
                doctorsQuery.data?.doctors.map((el) => {
                  return { ...el };
                }) || []
              }
              initialState={{
                density: "compact",
                showColumnFilters: true,
                columnVisibility: {
                  org_name: authUser()?.role === 1 ? true : false,
                },
                columnFilters: [
                  filter !== null
                    ? {
                        id: "is_active",
                        value: filter.is_active,
                      }
                    : {},
                ],
              }}
              enablePagination={true}
              enableBottomToolbar={true}
              enableTopToolbar={false}
              enableSorting={true}
              muiTablePaperProps={{
                elevation: 0,
              }}
              muiTableContainerProps={{
                sx: {
                  overflowX: "hidden",
                },
              }}
              muiTableBodyCellProps={{
                sx: {
                  overflowWrap: "anywhere",
                  whiteSpace: "break-spaces",
                },
              }}
              enableFacetedValues
              enableColumnResizing
              enableColumnActions={false}
              enableRowSelection={false}
              enableRowActions={true}
              displayColumnDefOptions={{
                "mrt-row-actions": { header: "Azioni" },
              }}
              positionActionsColumn="last"
              renderRowActionMenuItems={({ closeMenu, row, table }) => [
                <MenuItem
                  key="view"
                  onClick={() => {
                    openInEditMode.current = false;
                    handleOpenViewDoctor(row.original.id);
                    closeMenu();
                  }}
                >
                  <IconButton>
                    <ViewIcon color="primary" />
                  </IconButton>
                  Visualizza professionista
                </MenuItem>,

                <MenuItem
                  key="edit"
                  onClick={() => {
                    openInEditMode.current = true;
                    handleOpenViewDoctor(row.original.id);
                    closeMenu();
                  }}
                >
                  <IconButton>
                    {" "}
                    <EditIcon color="warning" />
                  </IconButton>
                  Modifica professionista
                </MenuItem>,

                <MenuItem
                  key="delete"
                  onClick={() => {
                    deleteMutation.mutate(row.original.id);
                    setSelectedDoctor(row.original.id);
                    closeMenu();
                  }}
                >
                  <IconButton>
                    {" "}
                    <DeleteIcon color="error" />
                  </IconButton>
                  Rimuovi professionista
                </MenuItem>,
              ]}
            />
          )
        )}
      </Paper>
    </main>
  );
}

export default Doctors;
